export default __webpack_public_path__ + "static/media/vertical-divider.9c9d8fb0.svg";